import { render } from "./TabNavItems.vue?vue&type=template&id=7245fe53"
import script from "./TabNavItems.vue?vue&type=script&lang=js"
export * from "./TabNavItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__